var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.52 14.248C22.568 13.848 22.6 13.432 22.6 13C22.6 12.568 22.568 12.152 22.504 11.752L25.208 9.64001C25.448 9.44801 25.512 9.09601 25.368 8.82401L22.808 4.39201C22.648 4.10401 22.312 4.00801 22.024 4.10401L18.84 5.38401C18.168 4.87201 17.464 4.45601 16.68 4.13601L16.2 0.744012C16.152 0.424012 15.88 0.200012 15.56 0.200012H10.44C10.12 0.200012 9.864 0.424012 9.816 0.744012L9.336 4.13601C8.552 4.45601 7.832 4.88801 7.176 5.38401L3.992 4.10401C3.704 3.99201 3.368 4.10401 3.208 4.39201L0.648 8.82401C0.488 9.11201 0.552 9.44801 0.808 9.64001L3.512 11.752C3.448 12.152 3.4 12.584 3.4 13C3.4 13.416 3.432 13.848 3.496 14.248L0.792 16.36C0.552 16.552 0.488 16.904 0.632 17.176L3.192 21.608C3.352 21.896 3.688 21.992 3.976 21.896L7.16 20.616C7.832 21.128 8.536 21.544 9.32 21.864L9.8 25.256C9.864 25.576 10.12 25.8 10.44 25.8H15.56C15.88 25.8 16.152 25.576 16.184 25.256L16.664 21.864C17.448 21.544 18.168 21.112 18.824 20.616L22.008 21.896C22.296 22.008 22.632 21.896 22.792 21.608L25.352 17.176C25.512 16.888 25.448 16.552 25.192 16.36L22.52 14.248ZM13 17.8C10.36 17.8 8.2 15.64 8.2 13C8.2 10.36 10.36 8.20001 13 8.20001C15.64 8.20001 17.8 10.36 17.8 13C17.8 15.64 15.64 17.8 13 17.8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.239b993c6b5794314cbef2a053a687d7.svg";
export { ForwardRef as ReactComponent };